import React from "react";
import { Alert } from "antd";
import { usePerfil } from "./usePerfil";
import { isLocalhost } from "../../apis/backend/Api";
import styles from "./styles.module.less";
import { selectStoreUsuarioActivo } from "../../redux/helpers/selectStore";
import { LazySuspense } from "../../components/layout/AppHeader/lazySuspense";

const AppHeader = React.lazy(
  () => import("../../components/layout/AppHeader/appHeader")
);
const AppFooter = React.lazy(
  () => import("../../components/layout/AppFooter/AppFooter")
);
export const ProtectedRoleCliente = ({
  children,
}: {
  children: JSX.Element;
}) => {
  const objUsuarioStore = selectStoreUsuarioActivo();
  let perfil = usePerfil("1");

  if (isLocalhost) return children;

  const perfilesPermitidos = ["7", "3", "4"];

  const tienePermiso = (idPerfil: string) =>
    perfilesPermitidos.includes(idPerfil);

  // Uso
  if (tienePermiso(objUsuarioStore.IdPerfil)) {
    return children;
  }

  if (!perfil.isPerfil) {
    return NotAuthorized();
  } else {
    return children;
  }
};
function NotAuthorized() {
  return (
    <>
      {" "}
      <AppHeader />
      <div className={styles.contentStyle}>
        <Alert message={"Usuario no autorizado"} type={"warning"} />
      </div>
      <LazySuspense>
        <AppFooter />
      </LazySuspense>
    </>
  );
}
